const want = {
  namespaced: true,
  state: {
    want: [2, 21, 26, 29]
  },
  getters: {
    getWant: (state) => state.want
  },
  mutations: {
    setWant (state, want) {
      state.want = want
    }
  },
  actions: {
    setWant ({ commit }, want) {
      commit('setWant', want)
    }
  }
}

export default want



// WEBPACK FOOTER //
// ./src/vuex/want.js